module.exports = __webpack_public_path__ + "static/media/grails.df485aa9.svg";